module.exports = __webpack_public_path__ + "img/xmas_surprise.611d0725.svg";